module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/node_modules/_core-js@2.6.12@core-js/modules/_function-to-string.js
// module id = ../../../../_core-js@2.6.12@core-js/modules/_function-to-string.js
// module chunks = polyfills